import { render, staticRenderFns } from "./shareTip.vue?vue&type=template&id=d670b2fe&scoped=true&"
import script from "./shareTip.vue?vue&type=script&lang=js&"
export * from "./shareTip.vue?vue&type=script&lang=js&"
import style0 from "./shareTip.vue?vue&type=style&index=0&id=d670b2fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d670b2fe",
  null
  
)

export default component.exports